/* Indigo Enamel — mobile buy bar behaviour.

   Two entry points, one sheet:
     "เพิ่มลงตะกร้า" → sheet → add to cart → theme's cart drawer
     "ซื้อเลย"       → sheet → cart permalink → checkout

   Buy-now deliberately uses the cart permalink, which REPLACES the cart with
   just this item and lands on checkout. That is the express-lane behaviour
   asked for; it does discard anything already in the cart.

   Theme internals this leans on — check these after any Reformation update:
     - theme.routes.*                       (layout/theme.liquid)
     - formatMoney()                        (vendor.min.js)
     - #Cart-Drawer / .active / body.open-cc / body.open-cart   (app.js ~506)
     - the sections contract for /cart/add  (product.js ~805 getSectionsToRender)
     - the product:variant-change event     (product.js ~54)
   A rename in any of them fails quietly, so each has a fallback below.
*/
(function () {
	'use strict';

	var bar = document.querySelector('[data-ie-mobile-buybar]');
	if (!bar) return;

	var sheet = document.querySelector('[data-ie-mb-sheet]');
	var scrim = document.querySelector('[data-ie-mb-scrim]');
	var qtyInput = sheet.querySelector('[data-ie-mb-qty]');
	var totalEl = sheet.querySelector('[data-ie-mb-total]');
	var barPrice = bar.querySelector('[data-ie-mb-barprice]');
	var confirmBtn = sheet.querySelector('[data-ie-mb-confirm]');
	var confirmLabel = sheet.querySelector('[data-ie-mb-confirm-label]');
	var errorEl = sheet.querySelector('[data-ie-mb-error]');
	var radios = Array.prototype.slice.call(sheet.querySelectorAll('input[name="ie-mb-variant"]'));

	var routes = (window.theme && window.theme.routes) || {};
	var root = (routes.root_url || '/').replace(/\/$/, '');
	var addUrl = routes.cart_add_url || '/cart/add';
	var cartUrl = routes.cart_url || '/cart';

	var mode = 'cart';
	var lastFocus = null;
	var closeTimer = null;
	var isOpen = false;
	var openedAt = 0;
	var submitting = false;

	function path(p) { return root + p; }

	/* Prices are shop-currency satang. Route through the theme's own formatter
	   so the bar cannot drift from every other price on the page, then drop the
	   trailing zeros to match the non-decimal house style. */
	function money(cents) {
		var fmt = window.theme && window.theme.settings && window.theme.settings.money_with_currency_format;
		if (typeof formatMoney === 'function' && fmt) {
			return formatMoney(cents, fmt).replace(/\.00(?!\d)/, '');
		}
		var v = cents / 100;
		var s = v % 1 === 0
			? v.toLocaleString('en-US')
			: v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		return s + ' ฿';
	}

	function buyable() {
		return radios.filter(function (r) { return !r.disabled; });
	}

	/* A checked-but-disabled radio is reachable: a ?variant= link to a sold-out
	   pack pre-checks it, and the page picker can sync one in. Never return it. */
	function selected() {
		return radios.filter(function (r) { return r.checked && !r.disabled; })[0] || null;
	}

	function ensureSelection() {
		if (selected()) return true;
		var first = buyable()[0];
		if (!first) return false;
		first.checked = true;
		return true;
	}

	function qty() {
		var n = parseInt(qtyInput.value, 10);
		return isNaN(n) || n < 1 ? 1 : Math.min(n, 999);
	}

	/* The field is free-typed, so "0" or "abc" would display while a quantity of
	   1 was actually charged. Write the resolved value back. */
	function normalizeQty() { qtyInput.value = qty(); }

	function showError(msg) {
		errorEl.textContent = msg;
		errorEl.hidden = false;
	}

	function clearError() {
		errorEl.hidden = true;
		errorEl.textContent = '';
	}

	function syncTotals() {
		var r = selected();
		var soldOut = !r;
		confirmBtn.disabled = soldOut || submitting;
		if (soldOut) {
			confirmLabel.textContent = 'สินค้าหมด';
			return;
		}
		confirmLabel.textContent = mode === 'buy' ? 'สั่งซื้อทันที' : 'เพิ่มลงตะกร้า';
		var unit = parseInt(r.dataset.price, 10);
		totalEl.textContent = money(unit * qty());
		barPrice.textContent = money(unit);
	}

	function focusable() {
		return Array.prototype.filter.call(
			sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
			function (el) { return el.offsetWidth || el.offsetHeight || el === document.activeElement; }
		);
	}

	function open(which) {
		window.clearTimeout(closeTimer);
		mode = which;
		clearError();
		confirmBtn.classList.toggle('ie-mb-confirm--buy', which === 'buy');
		lastFocus = document.activeElement;
		scrim.hidden = false;
		sheet.hidden = false;
		isOpen = true;
		openedAt = Date.now();
		document.body.classList.add('ie-mb-open');
		/* Flush layout so the transition has a from-state, then reveal in the
		   SAME task. Deferring this to requestAnimationFrame meant a dropped or
		   delayed frame left the sheet translated off-screen while the page was
		   already scroll-locked — an open dialog the shopper cannot see. */
		void sheet.offsetHeight;
		sheet.classList.add('is-open');
		scrim.classList.add('is-open');
		ensureSelection();
		syncTotals();
		var r = selected() || confirmBtn;
		r.focus();
	}

	function close(restoreFocus) {
		if (!isOpen) return;
		isOpen = false;
		sheet.classList.remove('is-open');
		scrim.classList.remove('is-open');
		document.body.classList.remove('ie-mb-open');
		window.clearTimeout(closeTimer);
		closeTimer = window.setTimeout(function () {
			sheet.hidden = true;
			scrim.hidden = true;
		}, 240);
		if (restoreFocus !== false && lastFocus) lastFocus.focus();
	}

	function busy(on) {
		submitting = on;
		confirmBtn.disabled = on || !selected();
		confirmBtn.classList.toggle('is-busy', on);
	}

	/* Same sections contract the theme's own product form uses, so the drawer
	   and bubble are rendered from the response BEFORE the drawer is shown —
	   otherwise it opens on the pre-add cart and visibly swaps. */
	var SECTIONS = [
		{ id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
		{ id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
	];

	function addToCart(id, quantity) {
		var body = new FormData();
		body.append('id', id);
		body.append('quantity', quantity);
		body.append('sections', SECTIONS.map(function (s) { return s.section; }).join(','));
		body.append('sections_url', window.location.pathname);

		return fetch(addUrl, {
			method: 'POST',
			headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
			body: body
		}).then(function (res) {
			/* A throttle or error page is not JSON; surface that as an error
			   rather than letting res.json() reject with something opaque. */
			return res.text().then(function (text) {
				var data;
				try { data = JSON.parse(text); } catch (e) { throw new Error(''); }
				if (!res.ok || data.status) throw new Error(data.description || data.message || '');
				return data;
			});
		});
	}

	function renderSections(data) {
		if (!data || !data.sections) return;
		SECTIONS.forEach(function (s) {
			var host = document.getElementById(s.id);
			var markup = data.sections[s.section];
			if (!host || !markup) return;
			var target = host.querySelector(s.selector) || host;
			var parsed = new DOMParser().parseFromString(markup, 'text/html').querySelector(s.selector);
			if (parsed) target.innerHTML = parsed.innerHTML;
		});
		if (typeof CartDrawer !== 'undefined') new CartDrawer();
	}

	function openCartDrawer() {
		var drawer = document.getElementById('Cart-Drawer');
		if (!drawer) { window.location.href = cartUrl; return; }
		document.body.classList.add('open-cc', 'open-cart');
		drawer.classList.add('active');
		document.dispatchEvent(new CustomEvent('cart-drawer:open'));
		drawer.focus();
	}

	bar.addEventListener('click', function (e) {
		var trigger = e.target.closest('[data-ie-mb-open]');
		if (trigger) open(trigger.dataset.ieMbOpen);
	});

	sheet.addEventListener('click', function (e) {
		if (e.target.closest('[data-ie-mb-close]')) { close(); return; }
		var step = e.target.closest('[data-ie-mb-step]');
		if (step) {
			qtyInput.value = Math.max(1, qty() + parseInt(step.dataset.ieMbStep, 10));
			syncTotals();
		}
	});

	sheet.addEventListener('change', function () { clearError(); syncTotals(); });
	qtyInput.addEventListener('input', syncTotals);
	qtyInput.addEventListener('blur', function () { normalizeQty(); syncTotals(); });

	/* The scrim sits above the bar, so the second tap of a double-tap would
	   otherwise land here and close the sheet the first tap just opened. */
	scrim.addEventListener('click', function () {
		if (Date.now() - openedAt < 350) return;
		close();
	});

	document.addEventListener('keydown', function (e) {
		if (!isOpen) return;
		if (e.key === 'Escape') { close(); return; }
		if (e.key !== 'Tab') return;
		/* aria-modal promises the background is unreachable; without this, Tab
		   walks straight out of the sheet and behind the scrim. */
		var items = focusable();
		if (!items.length) return;
		var first = items[0];
		var last = items[items.length - 1];
		if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
		else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
	});

	confirmBtn.addEventListener('click', function () {
		if (submitting) return;
		normalizeQty();
		var r = selected();
		if (!r) { showError('ตัวเลือกนี้สินค้าหมด กรุณาเลือกขนาดอื่น'); return; }
		var id = r.value;
		var n = qty();

		if (mode === 'buy') {
			/* Replaces the cart with this item and lands on checkout. */
			busy(true);
			window.location.href = path('/cart/' + id + ':' + n) +
				'?return_to=' + encodeURIComponent(path('/checkout'));
			return;
		}

		busy(true);
		clearError();
		addToCart(id, n)
			.then(function (data) {
				renderSections(data);
				/* Focus belongs in the drawer, not back on the bar behind it. */
				close(false);
				openCartDrawer();
			})
			.catch(function (err) {
				/* Keep the shopper in the sheet with an explanation rather than
				   dumping them on /cart mid-purchase with nothing added.
				   Shopify's own description is only worth showing when it came
				   back in Thai — otherwise a Thai shopper reads "Cannot find
				   variant". Fall back to our own wording. */
				console.error('[ie-mobile-buybar]', err);
				var raw = err && err.message;
				showError(/[฀-๿]/.test(raw || '') ? raw : 'เพิ่มสินค้าไม่สำเร็จ กรุณาลองอีกครั้ง');
			})
			.finally(function () { busy(false); });
	});

	/* Keep the bar's price honest when the shopper changes packs on the page
	   itself rather than in the sheet. */
	document.addEventListener('product:variant-change', function (e) {
		var variant = e.detail && e.detail.variant;
		if (!variant) return;
		var match = radios.filter(function (r) { return r.value === String(variant.id); })[0];
		if (!match || match.disabled) return;
		match.checked = true;
		syncTotals();
	});

	/* Shopify's draft-theme preview bar is fixed to the bottom with almost
	   exactly this bar's footprint, so on a phone it hides the buy bar
	   completely and the theme looks broken while being reviewed. Lift out of
	   its way. The preview bar only exists on an unpublished theme, so this
	   never applies to a published storefront — and it is a measured offset
	   rather than a z-index fight, which would put the bar over the cart
	   drawer. It loads asynchronously, hence the re-checks. */
	function clearPreviewBar() {
		var pbar = document.getElementById('PBarNextFrameWrapper');
		var h = (pbar && pbar.offsetHeight) || 0;
		bar.style.bottom = h ? h + 'px' : '';
		/* The sheet needs the same lift, or the confirm button sits under the
		   preview bar and cannot be tapped. Its height has to come down by the
		   same amount, otherwise the top of the sheet runs off screen. */
		sheet.style.bottom = h ? h + 'px' : '';
		sheet.style.maxHeight = h ? 'calc(88vh - ' + h + 'px)' : '';
	}

	clearPreviewBar();
	window.setTimeout(clearPreviewBar, 1200);
	window.setTimeout(clearPreviewBar, 3500);
	window.addEventListener('resize', clearPreviewBar);

	ensureSelection();
	syncTotals();
	bar.hidden = false;
})();
